import { HeldChargeResolution, type ClearChargeRequest } from "@models/billing";

// What each way of clearing an unconfirmed charge does, as the clear dialog
// explains it under each choice. It depends on the kind of charge, so each
// kind has its own copy for every choice (#469 round 1, finding 7).
export type ResolutionDetails = Record<ClearChargeRequest["resolution"], string>;

// Membership charges: a location's activation and a membership renewal.
export const MEMBERSHIP_RESOLUTION_DETAILS: ResolutionDetails = {
    [HeldChargeResolution.Voided]:
        "No money moved. Clearing re-arms billing, so the next run charges normally.",
    [HeldChargeResolution.Released]:
        "The money settled. We record the settled payment so the customer is not charged again.",
    [HeldChargeResolution.Settled]:
        "We'll confirm the transaction with Authorize.Net, then record the payment.",
};

// A returned-payment fee (API ClearUnconfirmedReturnedPaymentFee). Voided
// re-arms nothing on its own: the admin charges the fee again from the order,
// which the API allows only while no fee is recorded (a lost race leaves one
// recorded beside the unconfirmed charge). Released records the held
// transaction as the order's fee; Settled verifies the named transaction with
// Authorize.Net first, then records it as the fee.
export const RETURNED_PAYMENT_FEE_RESOLUTION_DETAILS: ResolutionDetails = {
    [HeldChargeResolution.Voided]:
        "No money moved, or it was refunded. If the order has no fee recorded, it can then be charged again from the order page.",
    [HeldChargeResolution.Released]:
        "The held charge settled. We record it as this order's fee.",
    [HeldChargeResolution.Settled]:
        "We'll confirm the transaction with Authorize.Net, then record it as this order's fee.",
};
